import { render, staticRenderFns } from "./approvedList.vue?vue&type=template&id=29da530c"
import script from "./approvedList.vue?vue&type=script&lang=js"
export * from "./approvedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports